import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { pad } from '@fcom/core/utils/format';

/**
 * Add leading zero to a number if needed (<10 for minLength 2)
 *
 * minLength Defines minimum length for number, default is 2
 * placeholder sets the padding character, default is '0'
 */
@Injectable()
@Pipe({
  name: 'finPad',
  pure: true,
  standalone: false,
})
export class PadPipe implements PipeTransform {
  transform(input: number | string, minLength = 2, placeholder = '0'): string {
    return pad(input, minLength, placeholder);
  }
}
